import { styled } from "@mui/material/styles";
import { Grid } from "@mui/material";

export const Container = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexFlow: "column",
  gap: "10px",
  backgroundColor: theme.palette.background.default,

  "& > .MuiPagination-root": {
    alignSelf: "flex-end",
  },
}));
